<template>
  <div class="withdraw-content">
    <div class="page-actions">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>NFT提现管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="page-actions">
      <span>自动过审开关:</span>
      <el-switch v-model="autoExamine" @change="changeAuto"></el-switch>
    </div>
    <div class="page-actions">
      <el-input v-model="searchInfo.userId" clearable placeholder="用户ID"></el-input>
      <el-input v-model="searchInfo.contractAddress" clearable placeholder="合约地址"></el-input>
      <el-input v-model="searchInfo.coinId" clearable placeholder="NFT ID"></el-input>
      <el-button type="primary" @click="getList({ page: 1 })">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>
    <el-card class="page-content">
      <el-tabs v-model="activeTab" type="border-card" @tab-click="changeTab">
        <el-tab-pane v-for="item in tabs" :key="item.name" :label="item.label" :name="item.name"></el-tab-pane>
      </el-tabs>
      <el-table :data="dataList" border style="width: 100%">
        <el-table-column label="用户发起提现时间">
          <template slot-scope="scope">
            {{scope.row.withdrawalApplyTime | moment}}
          </template>
        </el-table-column>
        <el-table-column label="用户ID" prop="userId" />
        <el-table-column label="所属链" prop="chainType" />
        <el-table-column label="合约地址" prop="contractAddress" />
        <el-table-column label="Token ID" prop="coinId" />
        <el-table-column label="提现地址" prop="withdrawalAddress" />
        <el-table-column label="交易哈希值" prop="hashAddress" />
        <el-table-column :label="activeTab === '8' ? '备注' : '操作'" width="150" align="center">
          <template slot-scope="scope">
           <div v-if="activeTab !== '8'">
             <el-button type="primary" size="small" v-if="activeTab === '0'" @click="passOrRejectWithdraw(scope.row, 2)">通过</el-button>
             <el-button type="danger" size="small" v-if="activeTab === '0' || activeTab === '5'" @click="passOrRejectWithdraw(scope.row, 8)">驳回</el-button>
             <el-button type="primary" size="small" v-if="['4', '6', '7'].includes(activeTab)" @click="reWithdraw(scope.row)">重新发起提现</el-button>
           </div>
           <div v-else>{{scope.row.remark ? JSON.parse(scope.row.remark)['zh'] : '--'}}</div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
          :size="pagination.size"
          :page="pagination.page"
          :total="total"
          @pageChanged="handlePageChanged"
      ></pagination>
    </el-card>
  </div>
</template>

<script>
import api from './api'
export default {
  name: "index",
  data() {
    return {
      autoExamine: false,
      searchInfo: {},
      pagination: {
        size: 10,
        page: 1
      },
      total: 0,
      tabs: [
        {name: '0', label: '待审核'},
        {name: '2', label: '已审核'},
        {name: '3', label: '区块网络发送中'},
        {name: '1', label: '提现成功'},
        {name: '4', label: '提现失败'},
        {name: '5', label: '提现地址错误'},
        {name: '6', label: 'NFT ID异常'},
        {name: '7', label: 'gas费不足'},
        {name: '8', label: '管理员撤销'}
      ],
      activeTab: '0',
      dataList: [{ userId: '111' }]
    }
  },
  components: {
    Pagination: () => import('@/components/pagination')
  },
  created() {
    this.getAuto()
    this.getList({}, '0')
  },
  methods: {
    async getAuto() {
      api.getAutoPass().then(res => {
        if (res.code === 0) {
          this.autoExamine = res.data === 'true' ? true : false
        }
      })
    },
    changeAuto(value) {
      api.setAutoPass({ value }).then(res => {
        if (res.code === 0) {
          this.$message({ message: '更新成功', type: 'success' })
        }
      }).finally(() => {
        this.getAuto()
      })
    },
    handlePageChanged(pageVal) {
      this.getList(pageVal, this.activeTab);
    },
    reset() {
      this.searchInfo = {}
    },
    async getList(data = {}, type) {
      const sendData = type ? { state: type } : {}
      api.getWithdrawList({
        ...this.searchInfo,
        ...this.pagination,
        ...data,
        ...sendData
      }).then(res => {
        if (res.code !== 0) return
        if (!type) {
          const list = res.data.records.sort((a, b) => a.state - b.state)
          if (list.length === 0) {
            this.dataList = []
            return
          }
          this.dataList = list.filter(item => item.withdrawalState === list[0].withdrawalState)
          this.activeTab = list[0].withdrawalState.toString()
        } else {
          this.dataList = res.data.records
        }

      })
    },
    changeTab(val) {
      this.activeTab = val.name || val;
      // todo 数据处理
      this.getList({}, this.activeTab)
    },
    // 驳回
    rejectWithdraw(row, type) {
      this.$confirm('确定驳回吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '已驳回!'
        });
      }).catch(() => {

      });
    },
    // 通过
    passOrRejectWithdraw(row, type) {
      const msg = type === 2 ? '通过' : '驳回'
      this.$confirm(`确定${msg}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: type === 2 ? 'success' : 'warning'
      }).then(() => {
        api.setPassOrReject({
          id: row.id,
          state: type
        }).then(res => {
          if (res.code === 0) {
            this.getList({}, this.activeTab)
            this.$message({
              type: 'success',
              message: `已${msg}!`
            });
          }
        })

      }).catch(() => {

      });
    },
    // 重新提现
    reWithdraw(row) {
      api.setPassOrReject({
        id: row.id,
        state: 2
      }).then(res => {
        if (res.code === 0) {
          this.getList({}, this.activeTab)
          this.$message({
            type: 'success',
            message: '已重新发起提现!'
          });
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.withdraw-content {
  .page-actions {
    .el-input {
      width: 200px;
      min-width: 200px;
    }
  }
  ::v-deep.el-tabs {
    border-bottom: none;
    .el-tabs__content {
      display: none;
    }
  }
}
</style>